@use "../../../styles/accessibility.scss";

.label {
  --ixf-label-font-color: var(--ixf-color-neutral-dk);
  --ixf-label-font-family: var(--ixf-font-family-main);
  --ixf-label-font-weight: var(--ixf-font-weight-main-medium);
  --ixf-label-font-size: 0.875rem;
  --ixf-label-line-height: 1.5rem;
  --ixf-label-required-indicator-color: var(--ixf-color-danger-dk);
  --ixf-label-padding-horizontal: var(--ixf-input-padding-horizontal, 0);
  --ixf-label-padding-vertical: 0;
  // 2 extra pixels here to accommodate for the gap between placeholder and text
  --ixf-label-transform: translateY(calc(1ch + 2px));

  width: 100%;
  height: 100%;
  color: var(--ixf-label-font-color);
  font-family: var(--ixf-label-font-family);
  font-weight: var(--ixf-label-font-weight);
  font-size: var(--ixf-label-font-size);
  line-height: var(--ixf-label-line-height);
  padding: var(--ixf-label-padding-vertical) var(--ixf-label-padding-horizontal);
  position: absolute;
  top: 0;
  transition: transform 50ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  transform: var(--ixf-label-transform);
  user-select: none;
  pointer-events: none;
  will-change: transform, font-size, line-height;

  &.isInteractive {
    user-select: auto;
    pointer-events: auto;
    cursor: pointer;
  }

  &.isFloating {
    --ixf-label-font-size: 0.75rem;
    --ixf-label-line-height: 0.75rem;
    --ixf-label-transform: translate(
      var(--ixf-input-label-active-offset-horizontal),
      var(--ixf-input-label-active-offset)
    );
  }

  &.hasError {
    --ixf-label-font-color: var(--ixf-input-error-color);
  }

  &.isHidden {
    @include accessibility.visually-hidden;
  }

  &.isFixed {
    position: relative;
    top: unset;
    left: unset;
    --ixf-label-transform: none;
  }

  .requiredIndicator {
    color: var(--ixf-label-required-indicator-color);
  }
}
